// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"b92d667d366fefae8c3d","678":"ad8cccb4917536f83bfd","774":"5b8b6b1713393cd87e81","883":"ab6cf1431f543122c823"}[chunkId] + ".js";
};